import React, { useState } from "react";
import { EmojiRain } from "./EmojiRain";
import "./styles.css";

export default function App() {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;

    setLoading(true);
    setStatus("");

    const formData = new FormData(form);
    const data = {
      name: formData.get("name"),
      telegram: formData.get("telegram"),
    };

    try {
      const response = await fetch("https://sheetdb.io/api/v1/l1wx5mav7nj8u", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: [data] }),
      });

      if (response.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Помилка відправки:", error);
      setStatus("success");
      form.reset();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center p-4 font-sans overflow-hidden bg-transparent">
      <EmojiRain />

      <div className="max-w-md w-full bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden border border-pink-100 z-10 animate-in fade-in slide-in-from-bottom-4 duration-700">
        <div className="bg-gradient-to-r from-pink-400 to-fuchsia-500 p-8 text-white text-center">
          <h1 className="text-xl md:text-2xl font-bold leading-tight">
            Заповніть, будь ласка, ваші дані для отримання безкоштовного місяця
            навчання у Vocal Camp 🎤
          </h1>
        </div>

        {status === "success" ? (
          <div className="p-12 text-center animate-in fade-in zoom-in duration-500">
            <div className="text-5xl mb-4 text-pink-500">✨</div>
            <h2 className="text-2xl font-bold text-pink-600 mb-2">Дякуємо!</h2>
            <p className="text-gray-600 mb-6">
              Ваші дані збережено. Готуйте голос до навчання!
            </p>
            <button
              onClick={() => setStatus("")}
              className="text-pink-500 font-medium hover:underline transition-all"
            >
              Надіслати ще одну заявку
            </button>
          </div>
        ) : (
          <form className="p-6 md:p-8 space-y-5" onSubmit={handleSubmit}>
            <div className="space-y-1">
              <label className="block text-sm font-semibold text-pink-700 ml-1">
                Ім'я та прізвище
              </label>
              <input
                name="name"
                type="text"
                placeholder="Максим Бондар"
                className="w-full px-4 py-3 rounded-xl border border-pink-200 focus:ring-2 focus:ring-pink-400 focus:border-transparent outline-none transition disabled:opacity-50"
                required
                disabled={loading}
              />
            </div>

            <div className="space-y-1">
              <label className="block text-sm font-semibold text-pink-700 ml-1">
                Нік у Telegram або номер телефону
              </label>
              <input
                name="telegram"
                type="text"
                placeholder="@vocal_student"
                className="w-full px-4 py-3 rounded-xl border border-pink-200 focus:ring-2 focus:ring-pink-400 focus:border-transparent outline-none transition disabled:opacity-50"
                required
                disabled={loading}
              />
            </div>

            <div className="flex items-start gap-3 py-1">
              <input
                type="checkbox"
                id="terms"
                className="mt-1 w-5 h-5 accent-pink-500 cursor-pointer shrink-0"
                required
              />
              <label
                htmlFor="terms"
                className="text-sm text-gray-600 cursor-pointer leading-relaxed"
              >
                Підтверджую ознайомлення з{" "}
                <button
                  type="button"
                  onClick={() => setShowModal(true)}
                  className="text-pink-600 font-bold underline hover:text-pink-700 transition"
                >
                  умовами акції
                </button>
              </label>
            </div>

            <div className="pt-2 space-y-4">
              <button
                type="submit"
                disabled={loading}
                className={`w-full text-white font-bold py-4 rounded-xl shadow-lg transition-all active:scale-95 ${
                  loading
                    ? "bg-pink-300 cursor-not-allowed"
                    : "bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:shadow-pink-200 hover:scale-[1.01]"
                }`}
              >
                {loading ? "Надсилаємо запит..." : "Отримати навчання ✨"}
              </button>
              <p className="text-[11px] text-gray-400 leading-relaxed text-center px-2">
                Перш ніж надіслати заявку, будь ласка, переконайтеся, що ви
                відповідаєте критеріям отримання бонусного місяця, ознайомившись
                із умовами.
              </p>
            </div>

            {status === "error" && (
              <p className="text-red-500 text-xs text-center mt-2 animate-pulse">
                Упс! Сталася помилка. Перевірте з'єднання.
              </p>
            )}
          </form>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-in fade-in duration-300">
          <div className="bg-white rounded-3xl max-w-sm w-full max-h-[85vh] flex flex-col shadow-2xl overflow-hidden animate-in zoom-in duration-200">
            {/* Заголовок */}
            <div className="p-6 pb-2 border-b border-gray-50">
              <h2 className="text-xl font-bold text-pink-600">Умови акції</h2>
            </div>

            <div className="flex-1 overflow-y-auto p-6 text-sm text-gray-600 space-y-4 custom-scrollbar">
              <p className="font-medium text-gray-800">
                Акція не поширюється на:
              </p>

              <ul className="space-y-3">
                <li className="flex gap-2">
                  <span className="text-pink-400">•</span>
                  <span>
                    Учнів, які в період з 01.01.2026 до 14.02.2026 (термін, коли
                    заняття проводилися нестабільно (більше ніж одна відміна на
                    тиждень) через ситуацію, пов'язану з проблемами в
                    енергетичній інфраструктурі) зробили паузу в навчанні або не
                    мали оплаченого абонемента.
                  </span>
                </li>
                <li className="flex gap-2">
                  <span className="text-pink-400">•</span>
                  <span>
                    Учнів, які заморозили курс або робили паузу в навчанні.
                  </span>
                </li>
                <li className="flex gap-2">
                  <span className="text-pink-400">•</span>
                  <span>
                    Учнів, у яких оплачено менше одного місяця навчання.
                  </span>
                </li>
              </ul>

              <div className="bg-pink-50 p-4 rounded-2xl border border-pink-100">
                <p>
                  Період з <strong>14.04.2026 до 14.05.2026</strong> є
                  безкоштовним і не враховуватиметься в абонемент для обраних
                  учасників, котрі зареєструвалися через цю форму та
                  відповідають критеріям участі в акції.
                </p>
              </div>

              <p>
                Безкоштовний період діє лише у зазначені дати. Його неможливо
                перенести, відпрацювати або передати іншій особі.
              </p>

              <p className="font-bold text-gray-800">
                Реєстрація триває до 16.04.2026.
              </p>

              <p className="text-xs pt-2 border-t border-gray-100">
                З усіх питань звертайтеся в Telegram:{" "}
                <a
                  href="https://t.me/nicaaok"
                  target="_blank"
                  rel="noreferrer"
                  className="text-pink-600 underline font-bold"
                >
                  @nicaaok
                </a>
              </p>
            </div>

            <div className="p-6 bg-gray-50">
              <button
                onClick={() => setShowModal(false)}
                className="w-full py-3 bg-gradient-to-r from-pink-500 to-fuchsia-600 text-white rounded-xl font-bold transition shadow-md active:scale-95 hover:opacity-90"
              >
                Зрозуміло
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
